/**
 * Тип торцевого подключения (ниппель / фланец) для клиентских пресетов.
 * Галочка «По стандартным изделиям» — как у ΔT.
 */

import { HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE } from './hydraulicSeparatorClientParams';
import {
  DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE,
  connectionTypeToCollectorCategoryLabel,
} from './distributionCollectorClientParams';

export const CLIENT_STANDARD_PRODUCTS_CONNECTION_LABEL = 'По стандартным изделиям';

/** Категории торца в клиентском каталоге (ниппель / фланец). */
export const CLIENT_END_CONNECTION_CATEGORY_CHOICES = ['Ниппели', 'Фланцы'];

/** true — ⌀/профиль коллектора из строки каталога (поле заблокировано). */
export function clientUsesPresetCollectorSize(state) {
  if (state == null) return true;
  if (state.clientPresetCollectorSize !== undefined) {
    return Boolean(state.clientPresetCollectorSize);
  }
  return true;
}

/** true — тип подключения из строки каталога (поле заблокировано). */
export function clientUsesPresetConnectionType(state) {
  if (state == null) return true;
  if (state.clientPresetConnectionType !== undefined) {
    return Boolean(state.clientPresetConnectionType);
  }
  return true;
}

/**
 * Галочка «По стандартным изделиям»: поля подключения заблокированы.
 * В таблице — тип/размер из строки каталога; свыше каталога — автоподбор (фланец по расходу).
 * Снятая галочка — ручной выбор как у инженера.
 */
export function clientUsesCatalogPresetConnection(state, constructionCtx) {
  if (!clientUsesPresetConnectionType(state)) return false;
  if (constructionCtx == null) return false;
  if (constructionCtx.overTable) return true;
  if (constructionCtx.constructionKeyKw == null) return false;
  return true;
}

/** nipple | flange по номиналу строки каталога гидроразделителя. */
export function getHydraulicSeparatorPresetConnectionType(presetKeyKw) {
  const row = HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  if (!row) return 'nipple';
  if (row.connectionType === 'nipple' || row.connectionType === 'flange') {
    return row.connectionType;
  }
  if (presetKeyKw >= 250) return 'flange';
  return 'nipple';
}

export function getHydraulicSeparatorPresetConnectionSize(presetKeyKw, connectionType) {
  const row = HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  if (!row) return null;
  const ct = connectionType === 'flange' ? 'flange' : 'nipple';
  const variant = row[ct];
  const sz = variant?.connectionSize ?? row.connectionSize;
  return sz != null ? Number(sz) : null;
}

/** «Ниппели» | «Фланцы» для распределительного коллектора. */
export function getDistributionCollectorPresetEndConnectionCategory(presetKeyKw) {
  const row = DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  if (!row) return 'Ниппели';
  if (row.connectionType) {
    return connectionTypeToCollectorCategoryLabel(row.connectionType);
  }
  if (presetKeyKw >= 250) return 'Фланцы';
  return 'Ниппели';
}

export function getDistributionCollectorPresetEndConnectionSize(presetKeyKw, categoryLabel) {
  const row = DISTRIBUTION_COLLECTOR_CLIENT_PARAMS_TABLE[presetKeyKw];
  if (!row) return null;
  if (row.nipple && row.flange) {
    const v = categoryLabel === 'Фланцы' ? row.flange : row.nipple;
    return v?.connectionSize != null ? Number(v.connectionSize) : null;
  }
  return row.connectionSize != null ? Number(row.connectionSize) : null;
}

export function categoryLabelToNippleOrFlangeType(categoryLabel) {
  return categoryLabel === 'Фланцы' ? 'flange' : 'nipple';
}
